import React from "react";
import { useForm } from "react-hook-form";
import { useState } from "react";
import {
  FirstName,
  LastName,
  Age,
  Gender,
  Phone,
  FirstNameKana,
  LastNameKana,
  Email
} from "features/Entries/field-input";

const ModalUpdatePartner = ({
  entry,
  partnerInfo,
  openFn,
  open,
  handleUpdatePartner,
  setPartnerInfo,
  list,
}) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();

  const [errorDisplay, setErrorDisplay] = useState([]);
  let errorValidate = [];

  // check partner with age - gender
  const checkPartner = (data) => {
    errorValidate = [];
    const { age, gender } = data;

    if(gender == 1) {
      if(entry.gender1 == '2' && entry.gender2 == '3' && entry.gender3 == '3') {
          errorValidate = [
            ...errorValidate,
            `当案件は同行者の登録が女性のみです`
          ];
      } else if (entry.gender1 == '3' && entry.gender2 == '2' && entry.gender3 == '3') {
          errorValidate = [
            ...errorValidate,
            `当案件は同行者の登録が女性のみです`
          ];
      } else if (entry.gender1 == '3' && entry.gender2 == '3' && entry.gender3 == '2') {
          errorValidate = [
            ...errorValidate,
            `当案件は同行者の登録が女性のみです`
          ];
      } else if (entry.gender1 == '2' && entry.gender2 == '2' && entry.gender3 == '3') {
          errorValidate = [
            ...errorValidate,
            `当案件は同行者の登録が女性のみです`
          ];
      } else if (entry.gender1 == '3' && entry.gender2 == '2' && entry.gender3 == '2') {
          errorValidate = [
            ...errorValidate,
            `当案件は同行者の登録が女性のみです`
          ];
      } else if (entry.gender1 == '2' && entry.gender2 == '2' && entry.gender3 == '2') {
          errorValidate = [
            ...errorValidate,
            `当案件は同行者の登録が女性のみです`
          ];
      } else {
        if(entry.gender1 == '' || entry.gender1 == '0' || entry.gender1 == '1' || entry.gender1 == '3') {
            if(entry.age1_from == '' && entry.age1_to != '') {
                if(age > entry.age1_to) {
                  errorValidate = [
                    ...errorValidate,
                    `男性の${entry.age1_to}才未満の年齢を入力してください`
                  ];
                }
            } else if(entry.age1_from != '' && entry.age1_to == '') {
                if(age < entry.age1_from) {
                  errorValidate = [
                    ...errorValidate,
                    `男性の${entry.age1_from}才超過年齢を入力してください`
                  ];
                }
            } else if(entry.age1_from != '' && entry.age1_to != '') {
                if(age < entry.age1_from ||  age > entry.age1_to) {
                  errorValidate = [
                    ...errorValidate,
                    `男性:${entry.age1_from}～${entry.age1_to}才以内の年齢を入力してください`
                  ];
                }
            }
        }
        
        if(entry.gender2 == '' || entry.gender2 == '0' || entry.gender2 == '1' || entry.gender2 == '3') {
            if(entry.age2_from == '' && entry.age2_to != '') {
                if(age > entry.age2_to) {
                  errorValidate = [
                    ...errorValidate,
                    `男性の${entry.age2_to}才未満の年齢を入力してください`
                  ];
                }
            } else if(entry.age2_from != '' && entry.age2_to == '') {
                if(age < entry.age2_from) {
                  errorValidate = [
                    ...errorValidate,
                    `男性の${entry.age2_from}才超過年齢を入力してください`
                  ];
                }
            } else if(entry.age2_from != '' && entry.age2_to != '') {
                if(age < entry.age2_from || age > entry.age2_to) {
                  errorValidate = [
                    ...errorValidate,
                    `男性:${entry.age2_from}～${entry.age2_to}才以内の年齢を入力してください`
                  ];
                }
            }
        }
        if(entry.gender3 == '' || entry.gender3 == '0' || entry.gender3 == '1' || entry.gender3 == '3') {
            if(entry.age3_from == '' && entry.age3_to != '') {
                if(age > entry.age3_to) {
                  errorValidate = [
                    ...errorValidate,
                    `男性の${entry.age3_to}才未満の年齢を入力してください`
                  ];
                }
            } else if(entry.age3_from != '' && entry.age3_to == '') {
                if(age < entry.age3_from) {
                  errorValidate = [
                    ...errorValidate,
                    `男性の${entry.age3_from}才超過年齢を入力してください`
                  ];
                }
            } else if(entry.age3_from != '' && entry.age3_to != '') {
                if(age < entry.age3_from || age > entry.age3_to) {
                  errorValidate = [
                    ...errorValidate,
                    `男性:${entry.age3_from}～${entry.age3_to}才以内の年齢を入力してください`
                  ];
                }
            }
        }
      }
    } else {
      if(entry.gender1 == '1' && entry.gender2 == '3' && entry.gender3 == '3') {
          errorValidate = [
            ...errorValidate,
            `当案件は同行者の登録が男性のみです`
          ];
      } else if (entry.gender1 == '3' && entry.gender2 == '1' && entry.gender3 == '3') {
          errorValidate = [
            ...errorValidate,
            `当案件は同行者の登録が男性のみです`
          ];
      } else if (entry.gender1 == '3' && entry.gender2 == '3' && entry.gender3 == '1') {
          errorValidate = [
            ...errorValidate,
            `当案件は同行者の登録が男性のみです`
          ];
      } else if (entry.gender1 == '1' && entry.gender2 == '1' && entry.gender3 == '3') {
          errorValidate = [
            ...errorValidate,
            `当案件は同行者の登録が男性のみです`
          ];
      } else if (entry.gender1 == '3' && entry.gender2 == '1' && entry.gender3 == '1') {
          errorValidate = [
            ...errorValidate,
            `当案件は同行者の登録が男性のみです`
          ];
      } else if (entry.gender1 == '1' && entry.gender2 == '1' && entry.gender3 == '1') {
          errorValidate = [
            ...errorValidate,
            `当案件は同行者の登録が男性のみです`
          ];
      } else {
        if(entry.gender1 == '' || entry.gender1 == '0' || entry.gender1 == '2' || entry.gender1 == '3') {
            if(entry.age1_from == '' && entry.age1_to != '') {
                if(age > entry.age1_to) {
                  errorValidate = [
                    ...errorValidate,
                    `女性の${entry.age1_to}才未満の年齢を入力してください`
                  ];
                }
            } else if(entry.age1_from != '' && entry.age1_to == '') {
                if(age < entry.age1_from) {
                  errorValidate = [
                    ...errorValidate,
                    `女性の${entry.age1_from}才超過年齢を入力してください`
                  ];
                }
            } else if(entry.age1_from != '' && entry.age1_to != '') {
                if(age < entry.age1_from || age > entry.age1_to) {
                  errorValidate = [
                    ...errorValidate,
                    `女性:${entry.age1_from}～${entry.age1_to}才以内の年齢を入力してください`
                  ];
                }
            }
        }
        if(entry.gender2 == '' || entry.gender2 == '0' || entry.gender2 == '2' || entry.gender2 == '3') {
            if(entry.age2_from == '' && entry.age2_to != '') {
                if(age > entry.age2_to) {
                  errorValidate = [
                    ...errorValidate,
                    `女性の${entry.age2_to}才未満の年齢を入力してください`
                  ];
                }
            } else if(entry.age2_from != '' && entry.age2_to == '') {
                if(age < entry.age2_from) {
                  errorValidate = [
                    ...errorValidate,
                    `女性の${entry.age2_from}才超過年齢を入力してください`
                  ];
                }
            } else if(entry.age2_from != '' && entry.age2_to != '') {
                if(age < entry.age2_from || age > entry.age2_to) {
                  errorValidate = [
                    ...errorValidate,
                    `女性:${entry.age2_from}～${entry.age2_to}才以内の年齢を入力してください`
                  ];
                }
            }
        }
        if(entry.gender3 == '' || entry.gender3 == '0' || entry.gender3 == '2' || entry.gender3 == '3') {
            if(entry.age3_from == '' && entry.age3_to != '') {
                if(age > entry.age3_to) {
                  errorValidate = [
                    ...errorValidate,
                    `女性の${entry.age3_to}才未満の年齢を入力してください`
                  ];
                }
            } else if(entry.age3_from != '' && entry.age3_to == '') {
                if(age < entry.age3_from) {
                  errorValidate = [
                    ...errorValidate,
                    `女性の${entry.age3_from}才超過年齢を入力してください`
                  ];
                }
            } else if(entry.age3_from != '' && entry.age3_to != '') {
                if(age < entry.age3_from || age > entry.age3_to) {
                  errorValidate = [
                    ...errorValidate,
                    `女性:${entry.age3_from}～${entry.age3_to}才以内の年齢を入力してください`
                  ];
                }
            }
        }
      }
    }
    setErrorDisplay(errorValidate);
    return errorValidate.length < 1 ? true : false;
  };

  const handleClearErrorAge = () => {
    if (errorDisplay) {
      setErrorDisplay([]);
    }
  };

  const onSubmit = (data) => {
    if (checkPartner(data)) {
      handleUpdatePartner(partnerInfo, {
        id: partnerInfo.id,
        ...data,
      });
      setPartnerInfo(null);
      setErrorDisplay([]);
      reset();
      openFn("modal-partner");
    }
  };

  const closeModal = () => {
    errorValidate = [];
    setErrorDisplay([]);
    reset();
    openFn("modal-partner");
  };

  return (
    partnerInfo &&
    open && (
      <form onSubmit={handleSubmit(onSubmit)} className="modal rounded-8 active">
        <div className="modal-body">
          <div className="title mt-2 text-black">同行者情報を修正する</div>

          <div className="px-3 px-md-5 my-4">
            {errorDisplay.length > 0 &&
              errorDisplay.map((err, index) => (
                <div key={index} className="alert alert-danger mt-2">
                  {err}
                </div>
              ))}
            <div className="my-3">
              <div className="form-group">
                <label className="mb-2">お名前</label>
                <div className="row gx-3">
                  <div className="col-12 col-md-6">
                    <LastName
                      partnerInfo={partnerInfo}
                      register={register}
                      errors={errors}
                    />
                  </div>
                  <div className="col-12 col-md-6 mt-2 mt-md-0">
                    <FirstName
                      partnerInfo={partnerInfo}
                      register={register}
                      errors={errors}
                    />
                  </div>
                </div>
                <div className="row gx-3 mt-2">
                  <div className="col-12 col-md-6">
                    <LastNameKana
                      partnerInfo={partnerInfo}
                      register={register}
                      errors={errors}
                    />
                  </div>
                  <div className="col-12 col-md-6 mt-2 mt-md-0">
                    <FirstNameKana
                      partnerInfo={partnerInfo}
                      register={register}
                      errors={errors}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="my-3">
              <div className="form-group">
                <label className="mb-2">
                  年齢<span></span>
                  <span>半角数字</span>
                </label>
                <div className="row gx-3">
                  <div className="w-82">
                    <Age
                      partnerInfo={partnerInfo}
                      register={register}
                      errors={errors}
                      errorAge={errorDisplay.length > 0 ? true : false}
                      clearError={handleClearErrorAge}
                    />
                  </div>
                </div>
                {errors?.age && (
                  <div className="alert alert-danger mt-2">
                    {errors.age?.message}
                  </div>
                )}
              </div>
            </div>
            <div className="my-3">
              <div className="form-group">
                <label className="mb-2">性別</label>
                <div >                  
                    <Gender
                      register={register}
                      value={1}
                      id={1}
                      label="男性"
                      partnerInfo={partnerInfo}
                      errors={errors}
                    />                
                    <Gender
                      register={register}
                      value={2}
                      id={2}
                      label="女性"
                      partnerInfo={partnerInfo}
                      errors={errors}
                    />                 
                </div>
                {errors?.gender && (
                  <div className="alert alert-danger mt-2">
                    {errors.gender?.message}
                  </div>
                )}
              </div>
            </div>
            <div className="my-3">
              <div className="form-group">
                <label className="mb-2">
                  電話番号
                  <span>[必須]</span>
                  <span>半角数字・ハイフンなし</span>
                </label>
                <div className="row gx-2">
                  <div className="col-12 col-md-9">
                    <Phone
                      partnerInfo={partnerInfo}
                      register={register}
                      errors={errors}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="my-3">
              <div className="form-group">
                <label className="mb-2">
                メールアドレス
                  <span></span>
                  <span></span>
                </label>
                <div className="row gx-2">
                  <div className="col-12 col-md-9">
                    <Email
                      partnerInfo={partnerInfo}
                      register={register}
                      errors={errors}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center fs-12 flex-wrap fw-600 text-red">
            <span> ※身分証を確認させて頂く場合がございます。 </span>
            <span> お間違えのない様にお願いいたします。 </span>
          </div>

          <div className="my-3 text-center">
            <input
              type="submit"
              className="btn-custom red-light"
              value={"修正する"}
            />

            <div onClick={closeModal} className="btn-custom mt-2">
              キャンセル
            </div>
          </div>
        </div>
      </form>
    )
  );
};

export default ModalUpdatePartner;
